export default __webpack_public_path__ + "static/media/gergelim.59790ddd.svg";